import 'react-responsive-carousel/lib/styles/carousel.min.css';


import { Box } from '@mui/material';
import images from '../../../../../data/images.json';
import { Carousel } from 'react-responsive-carousel';

export default function MobilePicturesCarousel()
{
    const imageList = images.home.portraits;
    return(
            
            <Box
                sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    overflowY: 'hidden',
                    backgroundColor:'secondary.main',
                    zIndex: 0,
                }}
            >
                <Carousel
                    swipeable
                    emulateTouch
                    interval={5000}
                    showStatus={false}
                    showThumbs={false}
                    showIndicators={false}
                    autoPlay
                    infiniteLoop
                >
                    {imageList.map((image, i) => (
                        <div
                        key={i}
                        id={`APOSTOLIS_IMG_${i}`}
                        style={{
                            height: "100vh",
                            width: "100vw",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center"
                        }}
                        >
                        <img
                            src={image.src}
                            alt={image.alt}
                            style={{
                            maxHeight: "100%",
                            maxWidth: "100%",
                            objectFit: "contain", // keeps proportions, adds yellow around
                            }}
                        />
                        </div>
                    ))}
                </Carousel>
            
            </Box>)
}